import React, { useEffect, useState } from 'react';
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import useDraftEditor from '../../../../hooks/useDraftEditor';
import LectureAttendance from './lecture-attendance';
import GeneralLectureInformation from './general-lecture-information';
import { useTranslation } from 'react-i18next';
import { LECTURE_DETAILS_BODY_ATTENDANCE_LABEL, LECTURE_DETAILS_BODY_LECTURE_INFO_LABEL, LECTURE_DETAILS_BODY_NO_DESC } from '../../../../i18n/keyConstants';

const Accordion = ({ label, children, defaultOpen }) => {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <div
      style={{
        borderBottom: "1px solid lightgrey",
        padding: "16px 0px 16px 0px"
      }}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          cursor: "pointer"
        }}
        onClick={() => setOpen((prev) => !prev)}
      >
        <h4 style={{ margin: 0 }}>{label}</h4>
        <div style={{ display: "flex" }}>
          {open ? '⌃' : '⌄'}
        </div>
      </div>

      {open && (
        <div style={{ marginTop: "16px" }}>
          {children}
        </div>
      )}
    </div>
  )
}

const LeftPanel = ({ lecture }) => {
  const {
    editorState,
    setEditorState,
    jsonStringToEditorState
  } = useDraftEditor();

  const { t } = useTranslation('lectureDetailsBody');

  useEffect(() => {
    setEditorState(jsonStringToEditorState(lecture.description));
  }, [lecture])

  return (
    <div className='details-left-panel'>
      <div className='editor-left-panel' style={{ position: "sticky", top: 83.75 }}>
        <Accordion label='Beskrivning' defaultOpen>
          <Editor className='col-6 text-center'
            editorState={editorState}
            readOnly={true}
            toolbarHidden={true}
                      placeholder={t(LECTURE_DETAILS_BODY_NO_DESC)}
            wrapperClassName="wrapper-class-read-only"
            editorClassName="editor-class editor-readonly"
            toolbarClassName="toolbar-class"
          />
        </Accordion>
      </div>
    </div>
  );
}

const RightPanel = ({ lecture, lectureUser }) => {
  const { t } = useTranslation('lectureDetailsBody');
  return (
    <div className="details-right-panel">
      <div style={{ position: "sticky", top: 83.75 }}>
        <Accordion label={t(LECTURE_DETAILS_BODY_LECTURE_INFO_LABEL)} defaultOpen>
          <GeneralLectureInformation lecture={lecture} lectureUser={lectureUser} />
        </Accordion>
        
        {(lectureUser.editPermission || lectureUser.teacherPermission) &&(
                  <Accordion label={t(LECTURE_DETAILS_BODY_ATTENDANCE_LABEL)} defaultOpen>
              <div className="d-flex p-1">
                <LectureAttendance lecture={lecture} />
              </div>
            </Accordion>
        )}
      </div>
    </div>
  );
}

export default function LectureDetailsBody({ lecture, lectureUser }) {
  return (
    <div className='course-details-body' style={{ display: "flex", justifyContent: "space-between", flexWrap: "wrap-reverse" }}>
      <LeftPanel lecture={lecture} />
      <RightPanel lecture={lecture} lectureUser={lectureUser} />
    </div>
  )
}
